import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import ascendLogo from '../../../assets/ACS-Images/Ascend-Logo.png';

const InviteTeam = () => {
  const navigate = useNavigate();
  const [teamMembers, setTeamMembers] = useState([{ email: "", jobTitle: "" }]);

  const handleChange = (index, field, value) => {
    const updated = [...teamMembers];
    updated[index][field] = value;
    setTeamMembers(updated);
  };

  const handleAdd = () => {
    setTeamMembers([...teamMembers, { email: "", jobTitle: "" }]);
  };

  const handleDelete = (index) => {
    const updated = [...teamMembers];
    updated.splice(index, 1);
    setTeamMembers(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/onboarding/ftp-location");
  };

  return (
    <div className="w-full min-h-screen bg-white flex items-center justify-center">
      <form onSubmit={handleSubmit} className="w-full max-w-5xl px-fluid-3 md:px-fluid-4 py-fluid-4 space-y-fluid-3">
        {/* Logo and Progress */}
        <div className="flex flex-col items-center space-y-fluid-2">
          <img
            src={ascendLogo}
            alt="Ascend Logo"
            className="w-32 md:w-40 mb-fluid-2 hover:scale-105 transition-transform duration-300"
          />

          {/* Stepper */}
            <div className="flex items-center justify-center gap-fluid-2 mt-fluid-1 mb-fluid-2">
            {["Invite your team", "FTP Location", "Success"].map((label, idx) => {
                const currentStep = 0; // Set this to 1 or 2 on later screens
                const isActive = idx === currentStep;
                const isCompleted = idx < currentStep;

                return (
                <React.Fragment key={idx}>
                    {idx > 0 && <div className="w-8 border-t-2 border-gray-300"></div>}

                    <div className="flex flex-col items-center">
                    <div
                        className={`w-8 h-8 rounded-full font-semibold flex items-center justify-center
                        ${isCompleted ? "bg-[#223688] text-white border-2 border-[#223688]" : ""}
                        ${isActive ? "border-2 border-[#223688] bg-[#e8edff] text-[#223688]" : ""}
                        ${!isActive && !isCompleted ? "border border-gray-300 bg-white text-gray-400" : ""}`}
                    >
                        {idx + 1}
                    </div>
                    <span
                        className={`mt-fluid-0.5 text-sm font-semibold text-center
                        ${isActive ? "text-black" : ""}
                        ${!isActive && !isCompleted ? "text-gray-400" : ""}
                        ${isCompleted ? "text-[#223688]" : ""}`}
                    >
                        {label}
                    </span>
                    </div>
                </React.Fragment>
                );
            })}
            </div>

        </div>

        {/* Title */}
        <div className="text-center mb-fluid-4">
          <h1 className="text-fluid-xl font-bold">Invite your team</h1>
        </div>

       {/* Team Inputs */}
       <div className="max-h-[400px] overflow-y-scroll scrollbar scrollbar-thumb-gray-400 scrollbar-track-gray-100 pr-fluid-2">
        {teamMembers.map((member, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-fluid-2 items-center mb-fluid-2">
            <div>
                <label className="block text-sm font-medium mb-1">Email<span className="text-red-600">*</span></label>
                <input
                type="email"
                className="w-full border border-gray-300 rounded-lg px-fluid-input-x py-fluid-input-y"
                value={member.email}
                onChange={(e) => handleChange(index, "email", e.target.value)}
                required
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Job title<span className="text-red-600">*</span></label>
                <input
                type="text"
                className="w-full border border-gray-300 rounded-lg px-fluid-input-x py-fluid-input-y"
                value={member.jobTitle}
                onChange={(e) => handleChange(index, "jobTitle", e.target.value)}
                required
                />
            </div>
            <div className="flex justify-center md:justify-start mt-fluid-2">
            <button
            type="button"
            onClick={() => handleDelete(index)}
            className="bg-Delete-red text-white px-fluid-button-x py-fluid-button-y rounded-full hover:bg-red-700"
            >
            Delete
            </button>

            </div>
            </div>
        ))}
        </div>


       {/* Add More */}
        <div className="flex justify-center mt-fluid-2">
        <button
            type="button"
            onClick={handleAdd}
            className="flex items-center gap-fluid-1 text-[#191D23] text-sm font-medium hover:scale-[1.02] transition-transform"
        >
            <span className="w-5 h-5 border border-black rounded-full flex items-center justify-center">
            <Plus className="w-[10px] h-[10px] text-black" />
            </span>
            Add more
        </button>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center gap-6 mt-fluid-4">
          <button
            type="button"
            onClick={() => navigate("/onboarding/company-info")}
            className="w-40 px-fluid-button-x py-fluid-button-y border-2 border-[#223688] text-[#223688] rounded-full hover:bg-[#eef0ff] transition"
          >
            Back
          </button>
          <button
            type="submit"
            className="w-40 px-fluid-button-x py-fluid-button-y bg-[#223688] text-white rounded-full hover:bg-[#1c2c6d] transition"
          >
            Send invite
          </button>
        </div>

        {/* Skip */}
        <div className="text-center mt-fluid-2">
          <button
            type="button"
            onClick={() => navigate("/onboarding/ftp-location")}
            className="text-black underline text-base"
          >
            Skip this step, finish later.
          </button>
        </div>
      </form>
    </div>
  );
};

export default InviteTeam;
